(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["d99-build-your-look"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const sections = document.querySelectorAll('.d99-byl');

      sections.forEach((root) => {
        if (root.dataset.d99Bound === 'true') return;
        root.dataset.d99Bound = 'true';

        const buttons = Array.from(root.querySelectorAll('[data-d99-select]'));
        const summary = root.querySelector('[data-d99-look-summary]');
        const emptyText = root.dataset.emptyText || 'Choose one hoodie and one pair of denim.';
        const selected = { hoodie: null, denim: null };

        const updateSummary = () => {
          if (!summary) return;

          if (selected.hoodie && selected.denim) {
            summary.textContent = selected.hoodie + ' + ' + selected.denim;
          } else if (selected.hoodie) {
            summary.textContent = selected.hoodie + ' — now choose denim.';
          } else if (selected.denim) {
            summary.textContent = selected.denim + ' — now choose a hoodie.';
          } else {
            summary.textContent = emptyText;
          }
        };

        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            const card = button.closest('[data-d99-look-card]');
            if (!card) return;

            const column = card.dataset.column;
            const isPressed = button.getAttribute('aria-pressed') === 'true';

            root.querySelectorAll('[data-column="' + column + '"] [data-d99-select]').forEach((other) => {
              other.setAttribute('aria-pressed', 'false');
              other.textContent = 'Select';
              const otherCard = other.closest('[data-d99-look-card]');
              if (otherCard) otherCard.classList.remove('is-selected');
            });

            if (!isPressed) {
              button.setAttribute('aria-pressed', 'true');
              button.textContent = 'Selected';
              card.classList.add('is-selected');
              selected[column] = card.dataset.title;
            } else {
              selected[column] = null;
            }

            updateSummary();
          });
        });
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
